module.exports = __webpack_public_path__ + "img/icon_zj_bg.0c163fb5.png";